<template>
  <div class="box">
    <!-- 导航栏轮播图 -->
    <div class="box-top">
      <div class="topContent">
        <ul>
          <li v-for="(item, index) in navigationBar" :key="index">
            <router-link
              :to="item.routerLinkPath"
              :active-class="'topContentActive'"
              exact
              >{{ item.navigationBarName }}</router-link
            >
          </li>
        </ul>
      </div>

      <div class="carouselImage">
        <!-- <el-carousel :interval="5000" arrow="always" height="60vh" > -->
        <el-carousel :interval="5000" arrow="always" :height="carouselHeight">
          <el-carousel-item
            v-for="(item, index) in carouselImages"
            :key="index"
          >
            <img :src="item.src" alt="" />
            <div class="carouselImageCon">
              <div class="carouselImageConOne">{{ item.name }}</div>
              <!-- <div class="carouselImageConLine"></div> -->
              <div class="carouselImageConTwo">{{ item.detail }}</div>
              <button class="carouselImageConBut">{{ item.button }}</button>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </div>
</template>
    
    <script>
export default {
  name: "contentTop",

  //  存放变量的  注意组件中的data是个函数
  data() {
    return {
      // 导航栏
      navigationBar: [
        {
          navigationBarName: "首页",
          routerLinkPath: "/",
        },
        {
          navigationBarName: "关于我们",
          routerLinkPath: "/about",
        },
        {
          navigationBarName: "产品与服务",
          routerLinkPath: "/product",
        },
        {
          navigationBarName: "新闻与咨讯",
          routerLinkPath: "/news",
        },
      ],
      // 轮播图
      carouselImages: [
        {
          src: require("@/pro/轮播图1.webp"),
          name: "国禀科技\n——您更值得信赖的装修管家 ",
          detail: "资金监管 / 收房质检 / 装修监理 / 健康装修",
          button: "绿色装修，健康生活",
        },
        {
          src: require("@/pro/轮播图2.webp"),
          name: "国禀科技\n——您更值得信赖的装修管家 ",
          detail: "安心装修 / 品质空间 / 健康生活",
          button: "绿色装修，健康生活",
        },
      ],
    };
  },
  computed: {
    activeIndex() {
      return this.$route.path;
    },
    carouselHeight() {
      if (window.innerWidth <= 480) {
        return "32vh";
      } else if (window.innerWidth <= 768) {
        return "50vh";
      } else {
        return "60vh";
      }
    },
  },
  methods: {},
  mounted() {
    // 固定导航栏
    var headTop = document.querySelector(".topContent");
    window.onscroll = () => {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      if (top != 0) {
        headTop.style =
          "position:fixed;background-color:rgba(39,174,97);color:#000;";
      } else {
        headTop.style = "position:absolute;background:'';";
      }
    };
  },
  beforeDestroy() {},
};
</script>
    
<style lang="scss" scoped>
// 导航栏轮播图
.box-top {
  width: 100%;
  height: 60vh;
  position: relative;
  margin-bottom: 2rem;

  // 导航栏
  .topContent {
    position: absolute;
    width: 100%;
    z-index: 10;
    // width: inherit;
    // height: inherit;
    background-color: rgba(107, 180, 138, 0.3);
    color: #fff;
    top: 0;
    display: flex;
    justify-content: flex-end;
  }
  .topContent ul {
    height: 2rem;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-evenly;
    align-items: center;
    padding-right: 4rem;
  }
  .topContent ul li {
    height: 110%;
    box-sizing: border-box;
    // border-bottom: 0.2rem solid transparent;
    line-height: 2rem;
    padding: 0 1.2rem;
    cursor: pointer;
  }
  .topContent ul li a {
    color: inherit;
  }
  .topContentActive {
    border-bottom: 0.2rem solid #fff;
    color: #fff !important;
    font-weight: 700;
    padding-bottom: 0.5rem;
  }

  // 轮播图
  .carouselImage {
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    position: relative;
    margin: 0 auto;
    overflow: hidden;
  }

  .carouselImage img {
    width: 100%;
    height: 100%;
  }
  .carouselImageCon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 10rem;
    text-align: left;
    font-weight: 600;
    color: #fff;
  }
  .carouselImageConOne {
    white-space: pre-line;
    font-size: 1.9rem;
  }
  .carouselImageConLine {
    width: 100%;
    height: 10px;
    background: #fff;
    margin: 14px 0;
  }
  .carouselImageConTwo {
    color: #27ae61;
    font-size: 1.3rem;
    margin: 2rem 0;
  }
  .carouselImageConBut {
    // margin-top: 2rem;
    background: #27ae61;
    border: 1px solid #27ae61;
    color: #fff;
    padding: 10px;
  }
}

@media (max-width: 999px) {
  .carouselImage .carouselImageCon {
    left: 6rem;
  }
}

@media (max-width: 768px) {
  .box-top {
    height: 50vh;
  }
  .carouselImage .carouselImageCon {
    left: 6rem;
  }
}
@media (max-width: 480px) {
  .box-top {
    height: 32vh;
    .topContent ul {
      padding-right: 1.6rem;
    }
    .topContent ul li {
      padding: 0 0.4rem;
    }
    .carouselImage .carouselImageCon {
      left: 1rem;
      right: 1rem;
    }
    .carouselImageConOne {
      font-size: 1.4rem;
    }
    .carouselImageConTwo {
      color: #27ae61;
      font-size: 0.9rem;
      margin: 1rem 0;
    }
    .carouselImageConBut {
      font-size: 0.8rem;
      padding: 0.5rem 1rem;
    }
  }
}
</style>